<template>
  <div>
    <page-main
      :tableData="tableData"
      :loading="loading"
      @reload="loadData"
      ref="main"
      :shipmentCode="shipmentCode"
      :shipmentBookingCode="shipmentBookingCode"
      :shipmentStatus="shipmentStatus"
      :custCode="custCode"
    >
      <page-header
        ref="header"
        slot="header"
        @openDialog="openDialog"
        :shipmentStatus="shipmentStatus"
      />
    </page-main>
    <el-dialog
      v-if="visible"
      show-close
      visible
      width="500px"
      :title="'批量更新字段'"
      :close-on-click-modal="false"
      :before-close="() => cancel()"
      append-to-body
      v-el-dialog-drag
    >
      <el-form ref="form" :model="formData" size="small" :rules="rules">
        <el-row :gutter="10">
          <el-col :span="24" v-if="bookingNoVisible">
            <el-form-item :label="'FCR NO.'">
              <el-input v-model="formData.bookingNo" clearable :size="'small'" maxlength="50">
                ></el-input
              >
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="bookingNumberVisible">
            <el-form-item :label="'订舱单号'">
              <el-input v-model="formData.bookingNumber" clearable :size="'small'" maxlength="50">
                ></el-input
              >
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="customsNoVisible">
            <el-form-item :label="'关单号'" prop="customsNo">
              <el-input v-model="formData.customsNo" clearable :size="'small'" maxlength="50">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="consigneeVisible">
            <el-form-item :label="'收货人'">
              <dict-select
                url="/factory/shipment/customer/select"
                v-model="formData.consigneeCode"
                :body="consigneeParams"
                :placeholder="
                  $l('INDEX.form_placeholder_consignee') || '请选择收货人'
                "
                filterable
                clearable
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="cancel()">{{
          $l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button type="primary" size="small" @click="save()">{{
          $l('INDEX.btn_save') || '保存'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
import validate from '@/libs/util.validate'
export default {
  mixins: [BaseTable, EditLoading],
  components: { PageHeader, PageMain },
  props: {
    shipmentCode: { type: String, default: '' },
    shipmentBookingCode: { type: String, default: '' },
    shipmentStatus: { type: String, default: '' },
    custCode: { type: String, default: '' },
  },
  data() {
    return {
      visible: false,
      formData: {},
      listBookingContainerPoCode: [],
      bookingNoVisible: false,
      customsNoVisible: false,
      consigneeVisible: false,
      bookingNumberVisible: false,
      updateField: '',
      rules: {
        customsNo: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_cancelReason') || '请输入关单号',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  computed: {
    consigneeParams() {
      return { shipmentType: 'C', custCode: this.custCode }
    },
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      if (!this.shipmentBookingCode) return
      this.loading = true
      this.$api
        .shipmentBookingContainerPoListApi({
          shipmentCode: this.shipmentCode,
          shipmentBookingCode: this.shipmentBookingCode,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    getTableData() {
      return this.$refs.main.getTableData()
    },
    validate() {
      return this.$refs.main.validate()
    },
    openDialog(type) {
      const data = this.$refs.main.getCheckboxRecords()
      if (!data) return
      this.updateField = type
      switch (type) {
        case 'bookingNo':
          this.bookingNoVisible = true
          break
        case 'customsNo':
          this.customsNoVisible = true
          break
        case 'bookingNumber':
          this.bookingNumberVisible = true
          break
        case 'consignee':
          this.consigneeVisible = true
          break
        default:
          return
      }
      this.listBookingContainerPoCode = data
      this.visible = true
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        return
      }
      const params = {
        shipmentCode: this.shipmentCode,
        shipmentBookingCode: this.shipmentBookingCode,
        ...this.formData,
        listBookingContainerPoCode: this.listBookingContainerPoCode,
        updateField: this.updateField,
      }
      let saveApi = {}
      if (this.consigneeVisible) {
        saveApi = this.$api.shipmentBookingUpdateConsigneeApi({ ...params })
      } else {
        saveApi = this.$api.shipmentBookingUpdateNoApi({ ...params })
      }
      this.loadingOpen()
      saveApi
        .then(() => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: '更新成功！',
            type: 'success',
          })
          this.loadData()
          this.cancel()
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    cancel() {
      this.formData = {}
      this.visible = false
      this.bookingNoVisible = false
      this.customsNoVisible = false
      this.bookingNumberVisible = false
      this.consigneeVisible = false
      this.updateField = ''
    },
  },
}
</script>
